import { Check, Minus } from 'lucide-react';
import type { ReactNode } from 'react';

export type RingState = 'open' | 'current' | 'arrived' | 'delivered' | 'failed' | 'notTaken';

interface StatusRingProps {
  state: RingState;
  /** Nummer of teken in de ring; alleen bij `open`, `current` en `arrived` zichtbaar. */
  label?: string | number;
  size?: number;
  /** Wat een schermlezer hoort; elke status heeft vorm + kleur + tekst. */
  ariaLabel: string;
}

/** Statusring (README §Componenten): cirkel met rand of vulling, altijd met `aria-label`. */
export function StatusRing({ state, label, size = 30, ariaLabel }: StatusRingProps) {
  const iconSize = Math.round(size * 0.5);
  let content: ReactNode = label ?? '';
  if (state === 'delivered') content = <Check size={iconSize} strokeWidth={2} aria-hidden />;
  else if (state === 'failed' || state === 'notTaken') {
    content = <Minus size={iconSize} strokeWidth={2} aria-hidden />;
  }

  return (
    <span
      className={`ring ring--${state === 'notTaken' ? 'nottaken' : state}`}
      style={{ ['--ring-size' as string]: `${size}px` }}
      role="img"
      aria-label={ariaLabel}
    >
      {content}
    </span>
  );
}

export type ChipTone = 'neutral' | 'sent' | 'waiting' | 'failed' | 'onaccent';

interface StatusChipProps {
  tone?: ChipTone;
  children: ReactNode;
}

/** Statuschip: pill met stip én tekst — nooit alleen kleur. */
export function StatusChip({ tone = 'neutral', children }: StatusChipProps) {
  return (
    <span className={`chip chip--${tone}`}>
      <span className="chip__dot" aria-hidden />
      {children}
    </span>
  );
}
